import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

interface Props {
  updatedAt: string;
}

const defaultProps = {};

const DATE_UNITS = {
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1,
};

const getSecondsDiff = (timestamp) => {
  const datenow = Date.now();
  const newdate = new Date(timestamp).getTime();
  return (datenow - newdate) / 1000;
};

const getUnitAndValueDate = (secondsElapsed) => {
  for (const [unit, secondsInUnit] of Object.entries(DATE_UNITS)) {
    if (secondsElapsed >= secondsInUnit || unit === 'second') {
      const value = Math.floor(secondsElapsed / secondsInUnit) * -1;
      return { value, unit };
    }
  }
};

const TimeAgo = ({ updatedAt }: Props) => {
  const rtf = new Intl.RelativeTimeFormat();
  const secondsElapsed = getSecondsDiff(updatedAt);
  const { value, unit } = getUnitAndValueDate(secondsElapsed);
  return <>{rtf.format(value, unit)}</>;
};

TimeAgo.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default TimeAgo;
